// extracted by mini-css-extract-plugin
export default {"badge":"list_badge__VJBnF","blue":"list_blue__HuDmf","green":"list_green__PEMqj","orange":"list_orange__FnB6O","red":"list_red__1G7Zx"};